<template>
    <AppLayout v-bind="customerSharedData.getAppLayoutProps(pageMeta)">
        <div class="grid grid-cols-12 gap-4">
            <div
                v-for="company in localCompanies"
                :key="company.id.value"
                class="col-span-12 lg:col-span-4 gap-4"
            >
                <CompanyCard :company="company" />
            </div>
        </div>
    </AppLayout>
</template>

<script setup lang="ts">
    import AppLayout from '@/Shared/Layout/Customer/Topbar/AppLayout.vue'
    import CompanyCard from '@/Customer/Dashboard/Components/CompanyCard.vue'
    import type { PageMeta } from '@/Shared/AutoGenerated/Main'
    import CustomerSharedData from '@/Shared/Entity/CustomerSharedData'
    import Company from '@/App/Company/Entity/Company'

    interface IndexCompaniesProps {
        pageMeta: PageMeta
        customerSharedDataData: any
        companiesData: any[]
    }

    const props = defineProps<IndexCompaniesProps>()
    const customerSharedData = CustomerSharedData.hydrate(
        props.customerSharedDataData,
    )
    const localCompanies = Company.hydrateMultiple(props.companiesData)
</script>
